import { render, staticRenderFns } from "./YuyueRecord.vue?vue&type=template&id=187d4711&scoped=true"
import script from "./YuyueRecord.vue?vue&type=script&lang=js"
export * from "./YuyueRecord.vue?vue&type=script&lang=js"
import style0 from "./YuyueRecord.vue?vue&type=style&index=0&id=187d4711&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187d4711",
  null
  
)

export default component.exports